unit View.Scripts_Aliados.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, System.StrUtils, UConstantes, UHelperServer, XData.Web.Client,
  UUtils, UWeb.Enum, UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewScripts_AliadosList = class(TForm)
    Scripts_AliadosDataset: TXDataWebDataSet;
    Scripts_AliadosDatasetid: TIntegerField;
    Scripts_AliadosDatasetscript_id: TIntegerField;
    Scripts_AliadosDatasetstatus: TIntegerField;
    Scripts_AliadosDataseterro: TStringField;
    Scripts_AliadosDatasetinclusao: TDateTimeField;
    Scripts_AliadosDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    Scripts_AliadosDatasetdata_base: TXDataWebEntityField;
    Scripts_AliadosDatasetdata_execucao: TDateTimeField;
    Scripts_AliadosDatasetdata_basealiadoNome_Fantasia: TXDataWebDatasetField;
    Scripts_AliadosDatasetdata_basealiadoCNPJ: TXDataWebDatasetField;
    Scripts_AliadosDatasetdata_basetoken: TXDataWebDatasetField;
    Scripts_AliadosDatasetdata_basepath: TXDataWebDatasetField;
    tmrConsulta: TTimer;
    XDataWebClientVerificarScripts: TXDataWebClient;
    edtScriptErro: TEdit;
    edtScriptConteudo: TEdit;
    XDataWebClientGetScript: TXDataWebClient;
    cbbScriptStatus: TComboBox;
    Scripts_AliadosDatasetscript: TXDataWebEntityField;
    Scripts_AliadosDatasetscriptnome: TXDataWebDatasetField;
    edtScriptId: TEdit;
    edtScriptNome: TEdit;
    edtScriptObservacao: TEdit;
    Scripts_AliadosDatasetscriptobservacao: TXDataWebDatasetField;
    Scripts_AliadosDatasetdata_baseid: TXDataWebDatasetField;
    Scripts_AliadosDatasetdata_basealiado_id: TXDataWebDatasetField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure XDataWebClientVerificarScriptsLoad(Response: TXDataClientResponse);
    procedure XDataWebClientVerificarScriptsError(Error: TXDataClientError);
    procedure XDataWebClientGetScriptLoad(Response: TXDataClientResponse);
    procedure XDataWebClientGetScriptError(Error: TXDataClientError);
    procedure cbbScriptStatusChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewScripts_AliadosList: TFViewScripts_AliadosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewScripts_AliadosList }

procedure TFViewScripts_AliadosList.cbbScriptStatusChange(Sender: TObject);
var
  lFiltro : string;
begin
  case cbbScriptStatus.ItemIndex of
    0 : lFiltro := '';
    1 : lFiltro := 'status eq 0';
    2 : lFiltro := 'status eq 1';
    3 : lFiltro := 'status eq 2';
  end;

  edSearch.Text := EmptyStr;
  cbPageSize.ItemIndex := 0;

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.FDatasetPlugin.FFilterPadrao := lFiltro;
  FGridPlugin.Load;
end;

procedure TFViewScripts_AliadosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewScripts_AliadosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewScripts_AliadosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewScripts_AliadosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewScripts_AliadosList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewScripts_AliadosList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewScripts_AliadosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewScripts_AliadosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordScriptId,
  RecordScriptAliadoId,
  RecordScriptErro,
  RecordScriptNome,
  RecordScriptObservacao : string;

  [async]
  procedure ReexecutarScriptButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja reexecutar este script?')) then
    begin
      TUtils.ChamarDivLoading;
      XDataWebClientVerificarScripts.RawInvoke('IScripts_Service.ReexecutarScript', [RecordScriptAliadoId]);
    end;
  end;

  procedure DetalhesScriptButtonClick(Sender: TObject);
  begin
    edtScriptErro.Text := RecordScriptErro;
    edtScriptId.Text := RecordScriptId;
    edtScriptNome.Text := RecordScriptNome;

    if RecordScriptObservacao = 'null' then
      edtScriptObservacao.Text := ''
    else
      edtScriptObservacao.Text := RecordScriptObservacao;

    XDataWebClientGetScript.RawInvoke('IScripts_Service.ObterScript', [RecordScriptId]);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Scripts_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(Scripts_AliadosDataset.EntitySetName),
      Scripts_AliadosDataset.CurrentData
    );


    RecordScriptAliadoId := Scripts_AliadosDataset.FieldByName('id').AsString;
    RecordScriptId := Scripts_AliadosDataset.FieldByName('script_id').AsString;
    RecordScriptErro := Scripts_AliadosDataset.FieldByName('erro').AsString;
    RecordScriptNome := Scripts_AliadosDataset.FieldByName('script.nome').AsString;
    RecordScriptObservacao := Scripts_AliadosDataset.FieldByName('script.observacao').AsString;

    //Botão ver script
    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @DetalhesScriptButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Detalhes script');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
    Button.ElementHandle.setAttribute('data-bs-target', '#modal_detalhes_script');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_script_modal');


    //Botão reenviar script
    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-retweet"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_reexecutar_script');

    if TUtils.PossuiPermissao('scripts_aliados', TTipoPermissao.ALTERAR) and
      (Scripts_AliadosDataset.FieldByName('status').AsInteger = 2) then
    begin
      Button.OnClick := @ReexecutarScriptButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Reexecutar script');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewScripts_AliadosList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].Title, ['Aliado', 'Token Banco',
      'Caminho Banco', 'Ações']) of
      0, 1, 2 : AClassName := 'text-left';
      3 : AClassName := 'd-flex justify-content-center';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewScripts_AliadosList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['status']) of
      0:
      begin
        case StrToInt(AValue) of
          0 : AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Cadastrado</div>';
          1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Executado</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Erro</div>';
        end;
      end;
    end;
  end;
end;

procedure TFViewScripts_AliadosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('scripts_aliados', 'active');
  TUtils.SetValorDicionarioClasses('scripts_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_scripts', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Scripts_AliadosDataset,
    lcPaginator,
    lbPaginationInfo
  );

  if THelperServer.FQuery <> '' then
  begin
    if Pos('status eq 0', THelperServer.FQuery) > 0 then
      cbbScriptStatus.ItemIndex := 1
    else if Pos('status eq 1', THelperServer.FQuery) > 0 then
      cbbScriptStatus.ItemIndex := 2
    else
      cbbScriptStatus.ItemIndex := 3;

    FGridPlugin.FDatasetPlugin.FFilterPadrao := THelperServer.FQuery;
    THelperServer.FQuery := '';
  end;

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'script_id desc, status desc';

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewScripts_AliadosList.XDataWebClientGetScriptError(
  Error: TXDataClientError);
begin
  edtScriptConteudo.Text := 'Não foi possível carregar o script';
end;

procedure TFViewScripts_AliadosList.XDataWebClientGetScriptLoad(
  Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := TJSObject(TJSJSON.ParseObject(Response.ResponseText));
  edtScriptConteudo.Text := window.atob(string(lJSONObject['base_64']));
end;

procedure TFViewScripts_AliadosList.XDataWebClientVerificarScriptsError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Não foi possível reexecutar o script!' + SlineBreak +
    Error.ErrorMessage);
end;

procedure TFViewScripts_AliadosList.XDataWebClientVerificarScriptsLoad(
  Response: TXDataClientResponse);
begin
  TUtils.OcultarDivLoading;
  FGridPlugin.Load;
end;

procedure TFViewScripts_AliadosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.scripts_aliados.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.scripts_aliados.list.table');
  cbPageSize := TComboBox.Create('view.scripts_aliados.list.cbPageSize');
  edSearch := TEdit.Create('view.scripts_aliados.list.search');
  lcPaginator := TListControl.Create('view.scripts_aliados.list.pagination');
  edtScriptErro := TEdit.Create('edt_script_erro');
  edtScriptConteudo := TEdit.Create('edt_script_conteudo');
  cbbScriptStatus := TComboBox.Create('script_status');
  edtScriptId := TEdit.Create('edt_script_id');
  edtScriptNome := TEdit.Create('edt_script_nome');
  edtScriptObservacao := TEdit.Create('edt_script_observacao');
  Scripts_AliadosDataset := TXDataWebDataSet.Create(Self);
  Scripts_AliadosDatasetid := TIntegerField.Create(Self);
  Scripts_AliadosDatasetscript_id := TIntegerField.Create(Self);
  Scripts_AliadosDatasetstatus := TIntegerField.Create(Self);
  Scripts_AliadosDataseterro := TStringField.Create(Self);
  Scripts_AliadosDatasetinclusao := TDateTimeField.Create(Self);
  Scripts_AliadosDatasetalteracao := TDateTimeField.Create(Self);
  Scripts_AliadosDatasetdata_base := TXDataWebEntityField.Create(Self);
  Scripts_AliadosDatasetdata_execucao := TDateTimeField.Create(Self);
  Scripts_AliadosDatasetdata_basealiadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetdata_basealiadoCNPJ := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetdata_basetoken := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetdata_basepath := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetscript := TXDataWebEntityField.Create(Self);
  Scripts_AliadosDatasetscriptnome := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetscriptobservacao := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetdata_baseid := TXDataWebDatasetField.Create(Self);
  Scripts_AliadosDatasetdata_basealiado_id := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClientVerificarScripts := TXDataWebClient.Create(Self);
  XDataWebClientGetScript := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  edtScriptErro.BeforeLoadDFMValues;
  edtScriptConteudo.BeforeLoadDFMValues;
  cbbScriptStatus.BeforeLoadDFMValues;
  edtScriptId.BeforeLoadDFMValues;
  edtScriptNome.BeforeLoadDFMValues;
  edtScriptObservacao.BeforeLoadDFMValues;
  Scripts_AliadosDataset.BeforeLoadDFMValues;
  Scripts_AliadosDatasetid.BeforeLoadDFMValues;
  Scripts_AliadosDatasetscript_id.BeforeLoadDFMValues;
  Scripts_AliadosDatasetstatus.BeforeLoadDFMValues;
  Scripts_AliadosDataseterro.BeforeLoadDFMValues;
  Scripts_AliadosDatasetinclusao.BeforeLoadDFMValues;
  Scripts_AliadosDatasetalteracao.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_base.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_execucao.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_basealiadoNome_Fantasia.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_basealiadoCNPJ.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_basetoken.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_basepath.BeforeLoadDFMValues;
  Scripts_AliadosDatasetscript.BeforeLoadDFMValues;
  Scripts_AliadosDatasetscriptnome.BeforeLoadDFMValues;
  Scripts_AliadosDatasetscriptobservacao.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_baseid.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_basealiado_id.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClientVerificarScripts.BeforeLoadDFMValues;
  XDataWebClientGetScript.BeforeLoadDFMValues;
  try
    Name := 'FViewScripts_AliadosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'script_id';
      Title := 'C'#243'd. Script';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.aliado_id';
      Title := 'C'#243'd. Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.aliado.CNPJ';
      Title := 'Cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'Status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.id';
      Title := 'C'#243'd. Banco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.token';
      Title := 'Token Banco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base.path';
      Title := 'Caminho Banco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_execucao';
      Title := 'Execu'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    edtScriptErro.SetParentComponent(Self);
    edtScriptErro.Name := 'edtScriptErro';
    edtScriptErro.Left := 8;
    edtScriptErro.Top := 418;
    edtScriptErro.Width := 121;
    edtScriptErro.Height := 22;
    edtScriptErro.ChildOrder := 31;
    edtScriptErro.Enabled := False;
    edtScriptErro.HeightPercent := 100.000000000000000000;
    edtScriptErro.Text := 'edtScriptErro';
    edtScriptErro.WidthPercent := 100.000000000000000000;
    edtScriptConteudo.SetParentComponent(Self);
    edtScriptConteudo.Name := 'edtScriptConteudo';
    edtScriptConteudo.Left := 8;
    edtScriptConteudo.Top := 446;
    edtScriptConteudo.Width := 121;
    edtScriptConteudo.Height := 22;
    edtScriptConteudo.ChildOrder := 31;
    edtScriptConteudo.Enabled := False;
    edtScriptConteudo.HeightPercent := 100.000000000000000000;
    edtScriptConteudo.Text := 'edtScriptConteudo';
    edtScriptConteudo.WidthPercent := 100.000000000000000000;
    cbbScriptStatus.SetParentComponent(Self);
    cbbScriptStatus.Name := 'cbbScriptStatus';
    cbbScriptStatus.Left := 168;
    cbbScriptStatus.Top := 418;
    cbbScriptStatus.Width := 145;
    cbbScriptStatus.Height := 21;
    cbbScriptStatus.HeightPercent := 100.000000000000000000;
    cbbScriptStatus.TabStop := False;
    cbbScriptStatus.Text := 'TODOS';
    cbbScriptStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbScriptStatus, Self, 'OnChange', 'cbbScriptStatusChange');
    cbbScriptStatus.ItemIndex := 0;
    cbbScriptStatus.Items.BeginUpdate;
    try
      cbbScriptStatus.Items.Clear;
      cbbScriptStatus.Items.Add('TODOS');
      cbbScriptStatus.Items.Add('CADASTRADOS');
      cbbScriptStatus.Items.Add('EXECUTADOS');
      cbbScriptStatus.Items.Add('ERRO');
    finally
      cbbScriptStatus.Items.EndUpdate;
    end;
    edtScriptId.SetParentComponent(Self);
    edtScriptId.Name := 'edtScriptId';
    edtScriptId.Left := 168;
    edtScriptId.Top := 445;
    edtScriptId.Width := 121;
    edtScriptId.Height := 22;
    edtScriptId.ChildOrder := 31;
    edtScriptId.Enabled := False;
    edtScriptId.HeightPercent := 100.000000000000000000;
    edtScriptId.Text := 'edtScriptId';
    edtScriptId.WidthPercent := 100.000000000000000000;
    edtScriptNome.SetParentComponent(Self);
    edtScriptNome.Name := 'edtScriptNome';
    edtScriptNome.Left := 168;
    edtScriptNome.Top := 473;
    edtScriptNome.Width := 121;
    edtScriptNome.Height := 22;
    edtScriptNome.ChildOrder := 31;
    edtScriptNome.Enabled := False;
    edtScriptNome.HeightPercent := 100.000000000000000000;
    edtScriptNome.Text := 'edtScriptNome';
    edtScriptNome.WidthPercent := 100.000000000000000000;
    edtScriptObservacao.SetParentComponent(Self);
    edtScriptObservacao.Name := 'edtScriptObservacao';
    edtScriptObservacao.Left := 8;
    edtScriptObservacao.Top := 472;
    edtScriptObservacao.Width := 121;
    edtScriptObservacao.Height := 22;
    edtScriptObservacao.ChildOrder := 31;
    edtScriptObservacao.Enabled := False;
    edtScriptObservacao.HeightPercent := 100.000000000000000000;
    edtScriptObservacao.Text := 'edtScriptObservacao';
    edtScriptObservacao.WidthPercent := 100.000000000000000000;
    Scripts_AliadosDataset.SetParentComponent(Self);
    Scripts_AliadosDataset.Name := 'Scripts_AliadosDataset';
    Scripts_AliadosDataset.EntitySetName := 'Scripts_Aliados';
    Scripts_AliadosDataset.Connection := DMConnection.ApiConnection;
    Scripts_AliadosDataset.Left := 72;
    Scripts_AliadosDataset.Top := 144;
    Scripts_AliadosDatasetid.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetid.Name := 'Scripts_AliadosDatasetid';
    Scripts_AliadosDatasetid.FieldName := 'id';
    Scripts_AliadosDatasetid.Required := True;
    Scripts_AliadosDatasetscript_id.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetscript_id.Name := 'Scripts_AliadosDatasetscript_id';
    Scripts_AliadosDatasetscript_id.FieldName := 'script_id';
    Scripts_AliadosDatasetscript_id.Required := True;
    Scripts_AliadosDatasetstatus.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetstatus.Name := 'Scripts_AliadosDatasetstatus';
    Scripts_AliadosDatasetstatus.FieldName := 'status';
    Scripts_AliadosDatasetstatus.Required := True;
    Scripts_AliadosDataseterro.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDataseterro.Name := 'Scripts_AliadosDataseterro';
    Scripts_AliadosDataseterro.FieldName := 'erro';
    Scripts_AliadosDataseterro.Size := 255;
    Scripts_AliadosDatasetinclusao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetinclusao.Name := 'Scripts_AliadosDatasetinclusao';
    Scripts_AliadosDatasetinclusao.FieldName := 'inclusao';
    Scripts_AliadosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Scripts_AliadosDatasetalteracao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetalteracao.Name := 'Scripts_AliadosDatasetalteracao';
    Scripts_AliadosDatasetalteracao.FieldName := 'alteracao';
    Scripts_AliadosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Scripts_AliadosDatasetdata_base.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_base.Name := 'Scripts_AliadosDatasetdata_base';
    Scripts_AliadosDatasetdata_base.FieldName := 'data_base';
    Scripts_AliadosDatasetdata_execucao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_execucao.Name := 'Scripts_AliadosDatasetdata_execucao';
    Scripts_AliadosDatasetdata_execucao.FieldName := 'data_execucao';
    Scripts_AliadosDatasetdata_execucao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Scripts_AliadosDatasetdata_basealiadoNome_Fantasia.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_basealiadoNome_Fantasia.Name := 'Scripts_AliadosDatasetdata_basealiadoNome_Fantasia';
    Scripts_AliadosDatasetdata_basealiadoNome_Fantasia.FieldName := 'data_base.aliado.Nome_Fantasia';
    Scripts_AliadosDatasetdata_basealiadoCNPJ.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_basealiadoCNPJ.Name := 'Scripts_AliadosDatasetdata_basealiadoCNPJ';
    Scripts_AliadosDatasetdata_basealiadoCNPJ.FieldName := 'data_base.aliado.CNPJ';
    Scripts_AliadosDatasetdata_basetoken.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_basetoken.Name := 'Scripts_AliadosDatasetdata_basetoken';
    Scripts_AliadosDatasetdata_basetoken.FieldName := 'data_base.token';
    Scripts_AliadosDatasetdata_basepath.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_basepath.Name := 'Scripts_AliadosDatasetdata_basepath';
    Scripts_AliadosDatasetdata_basepath.FieldName := 'data_base.path';
    Scripts_AliadosDatasetscript.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetscript.Name := 'Scripts_AliadosDatasetscript';
    Scripts_AliadosDatasetscript.FieldName := 'script';
    Scripts_AliadosDatasetscriptnome.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetscriptnome.Name := 'Scripts_AliadosDatasetscriptnome';
    Scripts_AliadosDatasetscriptnome.FieldKind := fkCalculated;
    Scripts_AliadosDatasetscriptnome.FieldName := 'script.nome';
    Scripts_AliadosDatasetscriptnome.Calculated := True;
    Scripts_AliadosDatasetscriptobservacao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetscriptobservacao.Name := 'Scripts_AliadosDatasetscriptobservacao';
    Scripts_AliadosDatasetscriptobservacao.FieldKind := fkCalculated;
    Scripts_AliadosDatasetscriptobservacao.FieldName := 'script.observacao';
    Scripts_AliadosDatasetscriptobservacao.Calculated := True;
    Scripts_AliadosDatasetdata_baseid.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_baseid.Name := 'Scripts_AliadosDatasetdata_baseid';
    Scripts_AliadosDatasetdata_baseid.FieldKind := fkCalculated;
    Scripts_AliadosDatasetdata_baseid.FieldName := 'data_base.id';
    Scripts_AliadosDatasetdata_baseid.Calculated := True;
    Scripts_AliadosDatasetdata_basealiado_id.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_basealiado_id.Name := 'Scripts_AliadosDatasetdata_basealiado_id';
    Scripts_AliadosDatasetdata_basealiado_id.FieldKind := fkCalculated;
    Scripts_AliadosDatasetdata_basealiado_id.FieldName := 'data_base.aliado_id';
    Scripts_AliadosDatasetdata_basealiado_id.Calculated := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Scripts_AliadosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
    XDataWebClientVerificarScripts.SetParentComponent(Self);
    XDataWebClientVerificarScripts.Name := 'XDataWebClientVerificarScripts';
    XDataWebClientVerificarScripts.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientVerificarScripts, Self, 'OnLoad', 'XDataWebClientVerificarScriptsLoad');
    SetEvent(XDataWebClientVerificarScripts, Self, 'OnError', 'XDataWebClientVerificarScriptsError');
    XDataWebClientVerificarScripts.Left := 539;
    XDataWebClientVerificarScripts.Top := 432;
    XDataWebClientGetScript.SetParentComponent(Self);
    XDataWebClientGetScript.Name := 'XDataWebClientGetScript';
    XDataWebClientGetScript.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientGetScript, Self, 'OnLoad', 'XDataWebClientGetScriptLoad');
    SetEvent(XDataWebClientGetScript, Self, 'OnError', 'XDataWebClientGetScriptError');
    XDataWebClientGetScript.Left := 355;
    XDataWebClientGetScript.Top := 440;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    edtScriptErro.AfterLoadDFMValues;
    edtScriptConteudo.AfterLoadDFMValues;
    cbbScriptStatus.AfterLoadDFMValues;
    edtScriptId.AfterLoadDFMValues;
    edtScriptNome.AfterLoadDFMValues;
    edtScriptObservacao.AfterLoadDFMValues;
    Scripts_AliadosDataset.AfterLoadDFMValues;
    Scripts_AliadosDatasetid.AfterLoadDFMValues;
    Scripts_AliadosDatasetscript_id.AfterLoadDFMValues;
    Scripts_AliadosDatasetstatus.AfterLoadDFMValues;
    Scripts_AliadosDataseterro.AfterLoadDFMValues;
    Scripts_AliadosDatasetinclusao.AfterLoadDFMValues;
    Scripts_AliadosDatasetalteracao.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_base.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_execucao.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_basealiadoNome_Fantasia.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_basealiadoCNPJ.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_basetoken.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_basepath.AfterLoadDFMValues;
    Scripts_AliadosDatasetscript.AfterLoadDFMValues;
    Scripts_AliadosDatasetscriptnome.AfterLoadDFMValues;
    Scripts_AliadosDatasetscriptobservacao.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_baseid.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_basealiado_id.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClientVerificarScripts.AfterLoadDFMValues;
    XDataWebClientGetScript.AfterLoadDFMValues;
  end;
end;

end.
